var _path, _path2, _path3, _path4, _path5, _path6, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v341.337h512V85.329H0zm489.739 319.076h-267.13V107.59h267.13v296.815z",
  fill: "#ffda44"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M222.609 107.595h267.13V404.41h-267.13z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M22.261 107.595h200.348V404.41H22.261z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M200.348 85.334h22.261v341.337h-22.261z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M22.261 107.595h89.043V404.41H22.261z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9811",
  d: "M111.304 107.595h89.043V404.41h-89.043z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M358.675 250.438v-44.522c0-7.424-11.13-14.848-11.13-14.848s-11.13 7.424-11.13 14.848h-44.522v44.522h22.261v22.261c0 4.875.979 9.539 2.76 13.768l-10.184 8.493h-29.674V157.677c-12.299 0-22.261 9.973-22.261 22.261v96.467a22.19 22.19 0 007.413 16.584v35.361h14.848v-18.554h66.783v29.685H328.99v14.837h29.685v-29.685l13.601-14.837h44.288v29.685h-14.848v14.837h29.685v-29.685l13.601-14.837 12.552-40.259-11.038-19.1h-38.945c-14.169-.122-40.637.09-48.896.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370.551 211.844v25.229h71.513v13.365h4.452v-17.817h-71.513v-16.325h75.965v-4.452zM222.609 107.595h22.261v22.261h-22.261zm244.869 0h22.261v22.261h-22.261zM222.609 382.138h22.261v22.261h-22.261zm244.869 0h22.261v22.261h-22.261z"
}))));

export default SvgLk;